import { observer } from "mobx-react-lite";
import { useState } from "react";
import { MyInput, MyButton, MyDropdown } from "../../../components/Commons";
import { useAuthStore } from "../hooks/useAuthStore";
import { useTran } from "../../../hooks/useTran";
import { Lock, Mail } from "lucide-react";
import { Globe } from "lucide-react";
import { LANGUAGES } from "../../../constants/constants";
import { LOGIN, LOGIN_SIDEBAR_ITEMS } from "../constants/loginText.constants";

const LoginPage = observer(() => {
  const { login, errors } = useAuthStore();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [changeForm, setChangeForm] = useState(false);
  const { t, i18n } = useTran();

  const _handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    login({ email, password }).then(() => {
      setTimeout(() => setLoading(false), 800);
    });
  };

  const currentLang = LANGUAGES.find(
    ({ key }) => key === i18n.resolvedLanguage,
  );
  const match = currentLang?.value?.match(/\(([^)]+)\)/)[1];

  const _handleChangeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex flex-col md:flex-row h-full items-center justify-center overflow-y-hidden">
      <div
        className="hidden md:block w-full md:w-1/2 lg:w-1/2 xl:w-1/2 2xl:w-1/3 h-full p-7"
        style={{
          backgroundImage: 'url("/bg-login.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <img
          onClick={() => navigate("/")}
          src="/white-logo.png"
          className="w-[150px] cursor-pointer"
        />
        <p className="hidden lg:block text-secondary font-md text-lg mt-8 bg-black bg-opacity-40 p-3 rounded-md">
          {t(LOGIN.SIDEBAR_DES)}
        </p>
        {LOGIN_SIDEBAR_ITEMS.map((item, index) => {
          return (
            <div
              className="flex md:flex-row mt-7 justify-start items-center"
              key={index}
            >
              <div className="flex items-center justify-center mr-5">
                <item.icon size={34} color={"white"} />
              </div>
              <div>
                <p className="text-secondary font-bold text-lg">
                  {t(item.title)}
                </p>
                <p className="text-secondary font-sm">{t(item.label)}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div
        className="bg-white w-full md:max-w-md lg:max-w-full md:mx-auto md:mx-0 md:w-1/2 xl:w-2/3 h-full px-6 lg:px-16 xl:px-12
        flex items-center justify-center"
      >
        <div className="absolute top-4 right-4 z-10 flex gap-x-2.5 items-center">
          <MyDropdown
            align="right"
            trigger={
              <div className="px-2 h-10 cursor-pointer flex justify-center items-center gap-x-1 border-border border-[0.5px] rounded-[5px]">
                <Globe className="w-5 h-5" />
                <span className="mt-1">{match}</span>
              </div>
            }
            items={LANGUAGES.map(({ key, value }) => ({
              label: value,
              onClick: () => _handleChangeLanguage(key),
            }))}
          />
        </div>
        <div className="xl:w-1/2">
          <p className="text-heading font-extrabold text-3xl text-center">
            {t(LOGIN.LOGIN_WELCOME)}
          </p>
          <p className="text-muted font-normal text-lg text-center mt-3">
            {t(LOGIN.LOGIN_TEXT)}
          </p>
          {/* <div className="flex bg-secondary mt-10 rounded-md">
            <MyButton
              className={"w-1/2"}
              loading={loading}
              variant={`${!changeForm ? "default" : "secondary"}`}
              size={"lg"}
              onClick={() => setChangeForm(false)}
            >
              {t("Email")}
            </MyButton>
            <MyButton
              className={"w-1/2"}
              loading={loading}
              variant={`${changeForm ? "default" : "secondary"}`}
              size={"lg"}
              onClick={() => setChangeForm(true)}
              disabled
            >
              {t("SSO")}
            </MyButton>
          </div> */}
          <form onSubmit={_handleLogin}>
            {!changeForm && (
              <div className="w-full mt-6 justify-center">
                <MyInput
                  label={"Email"}
                  inputClassName={"py-6"}
                  icon={Mail}
                  placeholder="Email or Username"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={errors.email}
                />
                <MyInput
                  label={"Password"}
                  inputClassName={"py-6"}
                  className={"mt-6"}
                  icon={Lock}
                  placeholder="Password"
                  type="password"
                  id="password"
                  value={password}
                  loginPassword={true}
                  onChange={(e) => setPassword(e.target.value)}
                  error={errors.password}
                />
              </div>
            )}
            {changeForm && (
              <div className="w-full mt-6 justify-center">
                <MyInput
                  label={"Company Name"}
                  inputClassName={"py-6"}
                  // icon={Mail}
                  placeholder="Enter a company name"
                  id="companyName"
                  // value={email}
                  // onChange={(e) => setEmail(e.target.value)}
                  error={errors.email}
                />
              </div>
            )}
            <MyButton className="w-full mt-7" type="submit" loading={loading}>
              {t("Sign in")}
            </MyButton>
          </form>
          <hr className="my-10 border-muted w-full"></hr>
          <div className="flex justify-around">
            <img src="/GHG.svg" className="w-[130px]" />
            <img src="/ISO.svg" className="w-[130px]" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default LoginPage;
